import script from "./DesktopTuto.vue?vue&type=script&lang=ts&setup=true"
export * from "./DesktopTuto.vue?vue&type=script&lang=ts&setup=true"

import "./DesktopTuto.vue?vue&type=style&index=0&id=426175ee&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src462465770/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-426175ee"]])

export default __exports__